import { Howl } from "howler";
import coinSoundFile from "@/assets/sounds/coin.mp3";

const moneySound = new Howl({
  src: [coinSoundFile],
  volume: 0.8,
});

export const playMoneySound = () => {
  moneySound.play();
};
